import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from 'src/app/_core/_services/api.service';

@Injectable({
  providedIn: 'root'
})
export class NetworkPortalInvoicesService {
  constructor(private api: ApiService) {}

  getInvoices() {
    return this.api.getAPI('network-portal/billing/invoices').pipe(
      map((res) => {
        return res.body.results;
      })
    );
  }
}
